// Add your custom JS here.
(function ($) {
    // Fade in effects
    AOS.init();

    // Smooth anchor scrolling

    var swiper = new Swiper(".swiper-section-two", {
        slidesPerView: 1,
        center: true,
        loop: false,

        navigation: {
            nextEl: ".swiper-section-two-next",
            prevEl: ".swiper-section-two-prev",
        },
        breakpoints: {
            768: {
                spaceBetween: 0,
            },
            1024: {
                spaceBetween: 0,
            },
        },
    });

    var swiper = new Swiper(".section-two-repeater-3", {
        slidesPerView: 1,
        center: true,
        loop: false,

        navigation: {
            nextEl: ".section-two-repeater-3-next",
            prevEl: ".section-two-repeater-3-prev",
        },
        breakpoints: {
            768: {
                spaceBetween: 0,
            },
            1024: {
                spaceBetween: 0,
            },
        },
    });

    var swiper = new Swiper(".swiper-section-two-2", {
        slidesPerView: 1,
        spaceBetween: 80,
        center: true,
        loop: false,

        navigation: {
            nextEl: ".swiper-section-two-2-next",
            prevEl: ".swiper-section-two-2-prev",
        },
        breakpoints: {
            768: {
                spaceBetween: 0,
            },
            1024: {
                slidesPerView: 4,
            },
        },
    });

    var swiper = new Swiper(".section-three-repeater", {
        slidesPerView: 1,
        center: true,
        loop: false,

        navigation: {
            nextEl: ".section-two-repeater-3-next",
            prevEl: ".section-two-repeater-3-prev",
        },
        breakpoints: {
            768: {
                spaceBetween: 0,
            },
            1024: {
                spaceBetween: 0,
            },
        },
    });

    var swiper = new Swiper(".swiper-section-five", {
        slidesPerView: 1,
        spaceBetween: 80,
        center: true,
        loop: false,

        navigation: {
            nextEl: ".swiper-section-five-next",
            prevEl: ".swiper-section-five-prev",
        },
        breakpoints: {
            768: {
                spaceBetween: 0,
            },
            1024: {
                slidesPerView: 3,
            },
        },
    });

    //if screen is smaller than 1024px, make the swiper-section-two-2 a swiper
    if ($(window).width() < 1024) {
        var swiper = new Swiper(".section-five-repeater", {
            slidesPerView: 2,
            spaceBetween: 40,
            center: true,
            loop: false,

            navigation: {
                nextEl: ".section-five-repeater-next",
                prevEl: ".section-five-repeater-prev",
            },
            breakpoints: {
                768: {
                    spaceBetween: 0,
                },
                1024: {
                    spaceBetween: 50,
                },
            },
        });

        var swiper = new Swiper(".section-two-repeater-2", {
            slidesPerView: 2,
            spaceBetween: 40,
            center: true,
            loop: false,

            navigation: {
                nextEl: ".section-two-repeater-next-2",
                prevEl: ".section-two-repeater-prev-2",
            },
            breakpoints: {
                768: {
                    spaceBetween: 0,
                },
                1024: {
                    spaceBetween: 50,
                },
            },
        });
    }

    $(".tab-titles .title:first").addClass("active");
    $(".tabs-inner-wrapper .tab-inner:first").addClass("active");

    // Wanneer er op een tab-titel wordt geklikt
    $(".tab-titles .title").click(function () {
        // Verwijder de actieve klasse van alle tab-titels
        $(".tab-titles .title").removeClass("active");
        // Voeg de actieve klasse toe aan de geklikte tab-titel
        $(this).addClass("active");

        // Verkrijg de index van de geklikte tab-titel
        var index = $(this).index();
        // Verberg alle tab-inner-elementen
        $(".tabs-inner-wrapper .tab-inner").removeClass("active");
        // Laat alleen de tab-inner zien die overeenkomt met de geklikte tab-titel
        $(".tabs-inner-wrapper .tab-inner").eq(index).addClass("active");

        //when clicked on the title also scroll back to the top of the section (only on mobile)
    });

    //make .map-point slide in and out when clicked on .title sibling and close the others
    $(document).ready(function () {
        // Geef de eerste .map-point, .title en .map de klasse "active"
        $(".map-wrapper .map:first").addClass("active");
        $(".large .title:first").addClass("active");
        $(".large .map-point:first").addClass("active");

        // Klikfunctie voor .title elementen
        $(".large .title").click(function () {
            // Controleer of de titel al actief is
            if (!$(this).hasClass("active")) {
                // Verwijder de "active" klasse van alle .title elementen
                $(".large .title").removeClass("active");
                // Verwijder de "active" klasse van alle .map-point elementen
                $(".map-point").removeClass("active").slideUp();
                // Voeg de "active" klasse toe aan de geklikte .title
                $(this).addClass("active");
                // Zoek de bijbehorende .map-point en toon deze
                $(this).siblings(".map-point").slideDown().addClass("active");

                // Verkrijg de index van de geklikte titel
                var index = $(this).parent().index();

                console.log(index);
                // Laat de overeenkomstige .map verschijnen en vervaag de anderen
                $(".map-wrapper .map")
                    .fadeOut()
                    .removeClass("active")
                    .eq(index)
                    .fadeIn()
                    .addClass("active");
            }

            //scroll back to the map section when clicked on the title only on mobile
            if ($(window).width() < 1024) {
                $("html, body").animate(
                    {
                        scrollTop: $(".section-five-map").offset().top,
                    },
                    250
                );
            }
        });
    });

    $(document).ready(function () {
        var navbar = $("#wrapper-navbar");
        var sectionFold = $(".section-fold");

        $(window).scroll(function () {
            var windowHeight = $(window).height();
            var scrollPosition = $(window).scrollTop();
            var sectionFoldTop = sectionFold.offset().top;
            var sectionFoldBottom = sectionFoldTop + sectionFold.outerHeight();

            // Controleer of de hele section-fold buiten het zichtbare deel van het venster is
            if (
                sectionFoldTop > scrollPosition + windowHeight ||
                sectionFoldBottom < scrollPosition
            ) {
                navbar.addClass("scroll-full").removeClass("scroll-blur");
                $("#wrapper-navbar .button.white").addClass("bg-grey");
            } else {
                navbar.addClass("scroll-blur").removeClass("scroll-full");
                $("#wrapper-navbar .button.white").removeClass("bg-grey");
            }

            // Controleer of de scrollpositie helemaal bovenaan is
            if (scrollPosition === 0) {
                navbar.removeClass("scroll-blur");
            }
        });
    });

    $(".button.white.wide").on("click", function () {
        $(".background-video-popup").fadeIn();
    });

    $(".icon-close, .video-popup").on("click", function () {
        $(".background-video-popup").fadeOut();

        //also stop the vimeo video from playing

        var iframe = $(".background-video-popup iframe")[0].contentWindow;
        iframe.postMessage('{"method":"pause"}', "https://player.vimeo.com");
    });

    $(".wpml-language-switch").on("click", function () {
        $(".wpml-language-switch ul").toggleClass("active");
    });

    $(".toggle-mobile-menu").on("click", function () {
        $(this).toggleClass("active");
        $(".menu").toggleClass("active");
        $("#wrapper-navbar").toggleClass("mobile-active");
        $(".map").removeClass("mobile-toggle");
        //disable scroll when mobile menu is open
        $("body").toggleClass("no-scroll");
    });

    //when clicked on a menu item, close the menu
    $(".menu-item").on("click", function () {
        $(".toggle-mobile-menu").removeClass("active");
        $(".menu").removeClass("active");
        $("#wrapper-navbar").removeClass("mobile-active");
    });

    $(".map-toggle-mobile").on("click", function () {
        $(this).hide();
        $(".map").addClass("mobile-toggle");
        $(".toggle-mobile-menu-map").addClass("active");
        $(".backdrop-overlay").addClass("active");
    });

    $(".toggle-mobile-menu-map").on("click", function () {
        $(".map").removeClass("mobile-toggle");
        $(".toggle-mobile-menu-map").removeClass("active");
        $(".backdrop-overlay").removeClass("active");
        $(".map-toggle-mobile").show();
    });

    //if body does not have page-template-frontpage give .scroll-full to header
    if (!$("body").hasClass("page-template-frontpage")) {
        $("#wrapper-navbar").addClass("scroll-full");
    }

    //when u submit the form(#gform_1), scroll back to the form
    $("#gform_1").on("submit", function () {
        $("html, body").animate(
            {
                scrollTop: $("#gform_1").offset().top,
            },
            1000
        );
    });

    function pasHoogteAan() {
        var contentHeight = $(".section-five-map .content-wrapper").height();
        $(".map-wrapper .map img").height(contentHeight);
    }

    // Roep de functie aan bij het laden van de pagina
    $(document).ready(function () {
        pasHoogteAan();
    });

    // Roep de functie aan wanneer het venster wordt hertekend
    $(window).on("resize", function () {
        pasHoogteAan();
    });

    //make .section-four same height + 50px as .section-four .tab-inner.active recalculated when tab is clicked
    $(document).ready(function () {
        // Functie om de hoogte van de sectie te berekenen en in te stellen

        //make different offsets for different screen sizes

        if ($(window).width() < 1024) {
            var offset = 250;
        } else {
            var offset = 350;
        }

        function setSectionHeight() {
            var tabInnerHeight = $(".section-four .tab-inner.active").height();
            $(".section-four").height(tabInnerHeight + offset);
        }

        // Bij het laden van de pagina
        setSectionHeight();

        // Bij het klikken op de tab-titels
        $(".tab-titles .title").on("click", function () {
            // Reset de hoogte van de sectie
            setSectionHeight();
        });
    });

    //if screen is smaller than 1024px, make the swiper-section-two-2 a swiper
    if ($(window).width() < 1023) {
        //Extract each ._block from the wrappers and append them all to a single div

        $(".section-three-bottom .right ._block").each(function () {
            $(this).appendTo(
                ".section-three-bottom .right-mobile  .swiper-wrapper"
            );
            //give each ._block the .swiper-slide class
            $(
                ".section-three-bottom .right-mobile .swiper-wrapper ._block"
            ).addClass("swiper-slide");
        });

        var swiper = new Swiper(".right-mobile", {
            slidesPerView: 1,
            spaceBetween: 0,
            center: true,
            loop: false,

            navigation: {
                nextEl: ".right-mobile-next",
                prevEl: ".right-mobile-prev",
            },
            breakpoints: {
                768: {
                    spaceBetween: 0,
                },
                1024: {
                    slidesPerView: 1,
                },
            },
        });
    }

    $(".menu-item a").on("click", function () {
        $(".menu-item a").removeClass("active");
        $(this).addClass("active");
    });

    $(".mobile-menu-footer").appendTo(".menu-primary-menu-container");
    $(".mobile-menu-footer").appendTo(".menu-menu-1-container");

    //Check each menu item href value. And make them active if the section with the value as id is in view
    $(window).scroll(function () {
        var scroll = $(window).scrollTop();

        $(".menu-item a").each(function () {
            var href = $(this).attr("href");
            // href = href.replace("/", "").replace("es", ""); 

            var hashIndex = href.indexOf("#");
            var href = href.substring(hashIndex);
            
            var section = $(href);
            var sectionTop = section.offset().top;
            var sectionBottom = sectionTop + section.outerHeight();

            if (scroll >= sectionTop && scroll <= sectionBottom) {
                $(".menu-item a").removeClass("active");
                $(this).addClass("active");
            }
        });
    });




    // SMOOTH SCROLLING
    $('a[href*="#"]').on('click', function(e) {
        // Check if the anchor link is for the current page
        if (this.pathname === window.location.pathname && this.hash) {
            e.preventDefault(); // Prevent default anchor behavior

            var target = $(this.hash);
            if (target.length) {
                // Disable smooth scrolling temporarily
                $('html').css('scroll-behavior', 'auto');

                // Scroll to the target element
                $('html, body').animate({
                    scrollTop: target.offset().top
                }, 600, function() {
                    // Re-enable smooth scrolling after scrolling is complete
                    $('html').css('scroll-behavior', 'smooth');
                });
            }
        }
    });

    $("html[lang='es-ES'] #label_1_9_1 a").attr("href", "/es/politica-de-privacidad/");


})(jQuery);
